import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { SidelyBlack } from '../../../styles/global/css/Utils';

export const CalendarModalTitle = styled.div<{ noMargin?: boolean }>`
    ${DefaultText}
    color: ${SidelyBlack};
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    ${p => p.noMargin ? '' : 'margin-bottom: 20px;'}
`;

export const CalendarModalSubContainer = styled.div`
    width: 100%;
    padding: 0 20px;
`;
